import { render, staticRenderFns } from "./PropostaEncaminhadaCliente.vue?vue&type=template&id=ea2f0ece&"
import script from "./PropostaEncaminhadaCliente.vue?vue&type=script&lang=js&"
export * from "./PropostaEncaminhadaCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports